import { FlatTreeControl } from '@angular/cdk/tree';
import {
  Component,
  OnInit,
  Input,
  Output,
  ViewChild,
  EventEmitter,
  HostListener,
  ElementRef,
} from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatPaginator } from '@angular/material/paginator';
import { CURRENT_PAGE, SHOW_TOTAL_PAGES } from '../../../models/Constants';
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
} from '@angular/material/tree';
import { columnsModel } from '../../../models/customer.model';
import { InteractionHistoryService } from '../../../services/interaction-history.service';
import * as Constants from '../../../models/Constants';
import { MatTable } from '@angular/material/table';
import { MatSort, MatSortable } from '@angular/material/sort';
import _ from 'lodash';
import { RootScopeService } from '../../../services/root-scope.service';

interface TreeNode {
  _id: any;
  channelIcon: string;
  title?: any;
  agent: any;
  date: any;
  startTime: any;
  conversationId: any;
  topic: any;
  channel: any;
  documentDetail: any;
  messageDetails: any;
  csProDocDetails: any;
  begin: any;
  children?: TreeNode[];
  transferedData: TreeNode[];
  additionalAccountsData :TreeNode[];
  multipleAccountData: TreeNode[];
  initiated:any;
  mood:any;
}

interface ExampleFlatNode {
  _id: any;
  expandable: boolean;
  channelIcon: string;
  title?: any;
  agent: any;
  topic: any;
  date: any;
  startTime: any;
  conversationId: any;
  documentDetail: any;
  messageDetails: any;
  csProDocDetails: any;
  channel: any;
  level: number;
  begin: any;
  children: TreeNode[];
  transferedData: TreeNode[];
  additionalAccountsData :TreeNode[];
  multipleAccountData: TreeNode[];
  initiated:any;
  mood :any;
}

@Component({
  selector: 'app-tree-table',
  templateUrl: './tree-table.component.html',
  styleUrls: ['./tree-table.component.scss'],
})
export class TreeTableComponent implements  OnInit {
  displayedColumns: string[] = [
    'channelIcon',
    'date',
    'startTime',
    'topic',
    'agent',
    'conversationId',
    'mood'
  ];
  totalPage: number = 0;
  currentResizeIndex: number = 0;
  startX: number = 0;
  startWidth: number = 0;
  isResizingRight: boolean = true;
  isPreviousDisabled: boolean = true;
  isNextDisabled: boolean = true;
  @ViewChild(MatTable, { read: ElementRef }) private matTableRef!: ElementRef;
  /* istanbul ignore next */
  private transformer = (node: any, level: number) => {
    let obj: ExampleFlatNode = {
      _id: node._id,
      expandable: !!node.children && node.children.length > 0,
      channelIcon: node.channelIcon,
      channel: node.channel,
      title: node.title,
      agent: node.agent,
      date: node.date,
      topic: node.topic,
      begin: node.begin,
      startTime: node.startTime,
      conversationId: node.conversationId,
      documentDetail: node.documentDetail,
      messageDetails: node.messageDetails,
      csProDocDetails: node.csProDocDetails,
      children: node.children,
      level: level,
      transferedData: node.transferedData,
      additionalAccountsData :node.additionalAccountsData,
      multipleAccountData: node.multipleAccountData,
      initiated :node.initiated,
      mood : node.mood
    };
    return obj;
  };
/* istanbul ignore next */
  treeControl = new FlatTreeControl<ExampleFlatNode>(
    (node) => node.level,
    (node) => node.expandable
  );
/* istanbul ignore next */
  treeFlattener = new MatTreeFlattener(
    this.transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  //paginated data to be displayed
  originalDataSource = new MatTreeFlatDataSource(
    this.treeControl,
    this.treeFlattener
  );

  noRecordFoundMsg: any = Constants.NO_RESULT_DISPLAY_MSG;
  @Output() rowSelection: EventEmitter<any> = new EventEmitter();
  @Input() rowPerPage: number = 10;
  public totalCount: string = Constants.DefaultTableRange;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  pageNumbers: any[] = [];
  @Input() selectedRow: any;
  pageSize: number = 8;
  pageIndex: number = 0;
  treeData: any[] = [];

  constructor(private initHistService: InteractionHistoryService, private rootScope: RootScopeService) {
    // console.log('treetable called', this.dataSource);
  }

  ngOnInit() {
    this.initHistService.dataSource.subscribe((data) => {
      if (data) {
        this.dataSource = new MatTreeFlatDataSource(
          this.treeControl,
          this.treeFlattener
        );
        this.originalDataSource.data = data;
        // console.log('tree table subcribed');
        this.pageSize = this.rowPerPage;
        this.setPaginator();

      }

    });
  }

  displayRed(data) {
    if (data['topic'] == 'Do Not Discuss')
      return true;
    else
      return false;
  }

  displayPagination() {
    return this.originalDataSource.data.length > 0;
  }

  getChevronIconClass(data) {
    if (this.treeControl.isExpanded(data)) {
      return 'chevron-down';
    } else {
      return 'chevron-right';
    }
  }

  getChevronIconClassDown(data) {
    if (!this.treeControl.isExpanded(data)) {
      return 'chevron-down';
    } else {
      return 'chevron-right';
    }
  }

  setPaginator() {
    this.setPage(1,true);
  }
  // pager object
  pager: any = {};

  setPage(page: number,firstload?) {
    // get pager object from service
    this.pager = this.getPager(
      this.originalDataSource.data.length,
      page,
      this.pageSize
    );
    this.totalCount = this.getRangeLabel(
      page - 1,
      this.pageSize,
      this.originalDataSource.data.length
    );
    this.createPaginationButton();
    // get current page of items
    let cloneTreeData = Object.assign([], this.originalDataSource.data);
    this.dataSource.data = cloneTreeData.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );

    if(!firstload){
      cloneTreeData[0];
    }

    if(!firstload && !this.selectedRow){
      cloneTreeData[0];
    }

    /**If selectedRow is child node - CCR1-6628 */
    for (let i = 0; i < this.dataSource?.data?.length; i++) {
      let each = this.dataSource?.data?.[i];
      if (each?.children && each?.children?.length > 0) {
        for (let j = 0; j < each?.children?.length; j++) {
          if (each?.children?.[j]?._id == this.selectedRow?._id) {
            this.selectedRow = each;
            break;
          }
        }
        if (this.selectedRow === each) {
          break;
        }
      }
    }
    
    this.onRowSingleClick(this.selectedRow);

  }

  createPaginationButton() {
    this.pageNumbers = [];
    for (let i = 1; i <= this.pager.totalPages; i++) {
      if (i <= SHOW_TOTAL_PAGES && CURRENT_PAGE < SHOW_TOTAL_PAGES) {
        this.pageNumbers.push(i);
      }
    }
  }

  getPager(totalItems: number, currentPage, pageSize) {
    // calculate total pages
    let totalPages = Math.ceil(totalItems / pageSize);

    // ensure current page isn't out of range
    if (currentPage < 1) {
      currentPage = 1;
    } else if (currentPage > totalPages) {
      currentPage = totalPages;
    }

    let startPage: number, endPage: number;
    if (totalPages <= 10) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= 6) {
        startPage = 1;
        endPage = 10;
      } else if (currentPage + 4 >= totalPages) {
        startPage = totalPages - 9;
        endPage = totalPages;
      } else {
        startPage = currentPage - 5;
        endPage = currentPage + 4;
      }
    }

    // calculate start and end item indexes
    let startIndex = (currentPage - 1) * pageSize;
    let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    // create an array of pages to ng-repeat in the pager control
    let pages = Array.from(Array(endPage + 1 - startPage).keys()).map(
      (i) => startPage + i
    );

    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages,
    };
  }

  createButtons() {
    this.pageNumbers = [];
    for (let i = 1; i <= this.totalPage; i++) {
      if (i <= SHOW_TOTAL_PAGES && CURRENT_PAGE < SHOW_TOTAL_PAGES) {
        this.pageNumbers.push(i);
      }
    }
  }

  tableFocusout() {
    this.selectedRow = null;
  }

  getChevronClass(data) {
    // console.log(this.treeControl.isExpanded(data))
    // console.log("data", data)
    if (this.treeControl.isExpanded(data))
      return true;
    else return false;
  }

  getTablePageRange(self) {
    setTimeout(() => {
      this.totalCount = this.getRangeLabel(
        this.pageIndex,
        this.pageSize,
        this.dataSource.data.length
      );
      this.setResizeHeight();
    }, 0);
  }

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length == 0 || pageSize == 0) {
      return `0 of ${length}`;
    }

    length = Math.max(length, 0);

    const startIndex = page * pageSize;

    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;

    return `${startIndex + 1} - ${endIndex} of ${length}`;
  };

  setResizeHeight(zero?) {
    const height = zero ? 0 : this.matTableRef?.nativeElement.offsetHeight + 2;
    const headers = Array.from(
      this.matTableRef?.nativeElement.children[0].querySelectorAll(
        'span.resize-handle'
      )
    );
    headers.forEach((el: any) => {
      el.style.height = height + 'px';
    });
  }

  goToFirstPage() {
    let currentPage = this.paginator.pageIndex;
    if (currentPage % 5 == 0) {
      let divisor = Math.floor(currentPage / 5);
      let startPageSize = 5 * divisor + 1;
      this.pageNumbers = [];
      for (
        let i = startPageSize;
        i < startPageSize + 5 && i <= this.totalPage;
        i++
      ) {
        this.pageNumbers.push(i);
      }
    }
  }

  sortChange(sortEvent) {
    // console.log('sortEvent', sortEvent);
    let data = this.originalDataSource.data;
    this.originalDataSource.data = data.sort((a, b) => {
      const isAsc = sortEvent.direction === 'asc';
      switch (sortEvent.active) {
        case 'channelIcon':
          return this.compare(a['title'], b['title'], isAsc);
        case 'date':
          return this.dateSort(a['date'], b['date'], isAsc);
        case 'startTime':
          return this.compare(a['startTime'], b['startTime'], isAsc);
        case 'topic':
          return this.compare(a['topic'], b['topic'], isAsc);
        case 'agent':
          return this.compare(a['agent'], b['agent'], isAsc);
        case 'conversationId':
          return this.compare(a['conversationId'], b['conversationId'], isAsc);
        default:
          return 0;
      }
    });
    // this.getTablePageRange(this);
    this.setPaginator();
    this.onRowSingleClick(this.originalDataSource.data[0]);
  }

  setGridSortAndPagination() {
    setTimeout(() => {
      this.totalPage = Math.ceil(this.dataSource.data.length / this.pageSize);
      this.setResizeHeight();
      this.createButtons();
      this.getTablePageRange(this);
    }, 1);
  }
  // CCR1-3138
  onTableRowEnter(row) {
    // console.log('method onTableRowEnter called,', row);
    this.onRowSingleClick(row);
  }
  // CCR1-3138
  onRowSingleClick(row) {
    if(row){
      let obj = {};
      obj['row'] = row;
      this.selectedRow = row;
      this.rowSelection.emit(obj);
    }
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (a == b) return 0;

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  dateSort(a, b, isAsc) {
    let x: any = new Date(a.date);
    let y: any = new Date(b.date);
    if (x == y) return 0;
    return (x - y ? -1 : 1) * (isAsc ? 1 : -1);
  }
  
   /**
   * 
   * @returns isFilterApplied check has been added now
   * as earlier filter option was disabled  whern there was no data but as per latest implemnetation story -
   * now filter option will be enabled and user can apply filter in this case too it was showing unexpected msg.
   * CCR1-2066
   */
  noRecord() {
    if ((this.originalDataSource.data && this.originalDataSource.data?.length == 0 && this.initHistService.IHListViewDataCAMap?.[this.rootScope.activeCustTab?.customerSessionId]?.length > 0) || 
      this.initHistService.IHListViewDataCAMap?.[this.rootScope.activeCustTab?.customerSessionId]?.isFilterApplied)
      this.noRecordFoundMsg = Constants.NO_RESULT_FILTTER;
    else {
      this.noRecordFoundMsg = Constants.USE_FILTER_MSG;
    }
      //CCR1-2071

    if(this.originalDataSource?.data && this.originalDataSource.data?.length && this.originalDataSource.data?.length != 0){
      return false;
    }
    else{
      return true;
    }
    
  }


  // hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  @HostListener('window:resize', ['$event'])
  /* istanbul ignore next */
  onResize(event) {
    // this.setTableResize(this.matTableRef.nativeElement.clientWidth);
  }

  isRowSelected(row) {
    return row._id == this.selectedRow?._id;
  }

  getValue(data) {
    // console.log("data =", data)
    return data['isExpanded'];
  }
}
